import { createContext } from "react";
import { SessionStore } from "./sessionStore";
import { StoreApi } from "zustand";

//This context is created in order to initialise the Zustand store with the translation and embedded props.
//https://docs.pmnd.rs/zustand/guides/initialize-state-with-props#store-creator-with-createstore

const SessionContext = createContext<StoreApi<SessionStore> | null>(null);

export default SessionContext;
